// src/components/ContactSection.jsx
import React from 'react';
import './ContactSection.css';

// Tüm lokasyon verileri
import sokulluImg     from '../assets/sokullu.jpg';
import ilkokulOrtaImg from '../assets/okul.jpg';
import dikmenVipImg   from '../assets/vipkurs.jpg';
import zezeAdres      from '../assets/zezeAdres.png';

const allLocations = [
  {
    id: 1,
    name: 'Sokullu Yeldeğirmeni Anaokulu',
    img: sokulluImg,
    address: 'Sokullu Mehmet Paşa, İğde Cd No:24, 06460 Çankaya/Ankara',
    phone: '0549 830 37 33',
    fax:   '0312 483 56 56',
    email: 'yeldegirmenicocukevi@gmail.com',
    embedSrc: 'https://maps.google.com/maps?q=39.8820359,32.8349811&z=17&output=embed'
  },
  {
    id: 3,
    name: 'Yeldeğirmeni İlkokulu & Ortaokul',
    img: ilkokulOrtaImg,
    address: 'Harbiye Mah., Hürriyet Cd., Zarif Sk. No:16, Çankaya/Ankara',
    phone: '0549 830 37 31',
    fax:   '0312 482 00 10',
    email: 'yeldegirmeni.ilkokulu@gmail.com',
    embedSrc: 'https://maps.google.com/maps?q=39.8906677,32.837679&z=16&output=embed'
  },
  {
    id: 4,
    name: 'Yeldeğirmeni VIP Kurs',
    img: dikmenVipImg,
    address: 'Dikmen Cd No:292, 06460 Çankaya/Ankara',
    phone: '0549 830 37 32',
    email: 'yeldegirmenivip@gmail.com',
    embedSrc: 'https://maps.google.com/maps?q=39.8771952,32.8362101&z=16&output=embed'
  },
  {
    id: 5,
    name: "ZEZE'nin Bahçesi – Eymir",
    img: zezeAdres,
    address: 'Kümeevler Cad. No:364 Eymir, 06540 Gölbaşı/Ankara',
    phone: '0549 722 55 30',
    email: 'yeldegirmeni.ilkokulu@gmail.com',
    embedSrc: 'https://maps.google.com/maps?q=39.801500,32.819000&z=15&output=embed'
  },
];

export default function ContactSection({
  excludeIds = [],
  titleOverrides = {}
}) {
  const locations = allLocations.filter(loc => !excludeIds.includes(loc.id));

  return (
    <section id="contact-section" className="contact-section">
      <h2>İletişim</h2>
      <div className="contact-cards">
        {locations.map(loc => {
          const displayName = titleOverrides[loc.id] || loc.name;
          const showFax = loc.id !== 4 && loc.id !== 5;
          return (
            <div key={loc.id} className="contact-card">
              <img src={loc.img} alt={displayName} className="contact-img" />
              <div className="info">
                <h3>{displayName}</h3>
                <p><strong>Adres:</strong> {loc.address}</p>
                <p>
                  <strong>Telefon:</strong>{' '}
                  <a href={`tel:${loc.phone.replace(/[^0-9+]/g, '')}`}>
                    {loc.phone}
                  </a>
                </p>
                {showFax && (
                  <p>
                    <strong>Telefon:</strong>{' '}
                    <a href={`tel:${loc.fax.replace(/[^0-9+]/g, '')}`}>
                      {loc.fax}
                    </a>
                  </p>
                )}
                <p>
                  <strong>E‑posta:</strong>{' '}
                  <a href={`mailto:${loc.email}`}>{loc.email}</a>
                </p>
              </div>
              <div className="map-container">
                <iframe
                  src={loc.embedSrc}
                  allowFullScreen
                  loading="lazy"
                  title={displayName}
                />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
